import { fiveMinutes } from 'queries/constants';
import { datasourceQueryKeys } from 'queries/queryKeys/datasourceKeys';
import { UseQueryOptions, useQuery } from 'react-query';
import { List } from 'services/PluginService';

type QueryReturnType = Awaited<ReturnType<typeof List>>;

/**
 * Get all plugins available to the current tenant
 * (all public plugins plus any plugins restricted to the current tenant).
 */
export const useAllPlugins = <T = QueryReturnType>(options?: UseQueryOptions<QueryReturnType, unknown, T, string[]>) =>
    useQuery(datasourceQueryKeys.list, List, {
        staleTime: fiveMinutes,
        cacheTime: fiveMinutes,
        keepPreviousData: true,
        ...options
    });
